import { render, staticRenderFns } from "./SuccessItem.vue?vue&type=template&id=2ca6f8a9&scoped=true"
import script from "./SuccessItem.vue?vue&type=script&lang=js"
export * from "./SuccessItem.vue?vue&type=script&lang=js"
import style0 from "./SuccessItem.vue?vue&type=style&index=0&id=2ca6f8a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6f8a9",
  null
  
)

export default component.exports